import { render, staticRenderFns } from "./ModalAjudaCidsCiaps.vue?vue&type=template&id=a3597246&scoped=true"
import script from "./ModalAjudaCidsCiaps.vue?vue&type=script&lang=js"
export * from "./ModalAjudaCidsCiaps.vue?vue&type=script&lang=js"
import style0 from "./ModalAjudaCidsCiaps.vue?vue&type=style&index=0&id=a3597246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3597246",
  null
  
)

export default component.exports